export default __webpack_public_path__ + "media/cursors/zoom-in-29b1a1f7.cur";